module.exports = __webpack_public_path__ + "static/media/database.cdcd7cc2.png";